import { InputNumberDesignTokens } from '@primeuix/themes/types/inputnumber';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/inputnumber/index.ts
const inp = componentCommon.inputnumber;
const inpCs = componentColorScheme.inputnumber;

export const InputNumberTelekomDT: InputNumberDesignTokens = {
  button: {
    width: t(inp.button.width),
    borderRadius: t(inp.button.border.radius),
    verticalPadding: t(inp.button.vertical.padding),
    background: t(inpCs.button.background),
    hoverBackground: t(inpCs.button.hover.background),
    activeBackground: t(inpCs.button.active.background),
    borderColor: t(inpCs.button.border.color),
    hoverBorderColor: t(inpCs.button.hover.border.color),
    activeBorderColor: t(inpCs.button.active.border.color),
    color: t(inpCs.button.color),
    hoverColor: t(inpCs.button.hover.color),
    activeColor: t(inpCs.button.active.color),
  },
};
